import { useEffect } from "react";

const GlobalFontStyleSync = () => {
  useEffect(() => {
    const getFontStack = (fontName) => {
      const serifFonts = ["Times New Roman", "Georgia"];
      return serifFonts.includes(fontName)
        ? `'${fontName}', serif`
        : `'${fontName}', sans-serif`;
    };

    const loadGlobalFonts = async () => {
      try {
        const response = await fetch("https://eventscons.com/eventbackendnew/api/choose-font", {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        const result = await response.json();

        if (!response.ok || !result?.status || !result?.data) {
          throw new Error(result?.message || "Failed to fetch global font settings");
        }

        const data = result.data;
        const root = document.documentElement;

        root.style.setProperty(
          "--global-heading-font-family",
          getFontStack(data.font_family || "Poppins")
        );
        root.style.setProperty(
          "--global-heading-font-weight",
          data.font_weight || "400"
        );
        root.style.setProperty(
          "--global-heading-color",
          data.heading_color || "#000000"
        );
        root.style.setProperty(
          "--global-heading-font-size",
          `${data.font_size || 35}px`
        );

        root.style.setProperty(
          "--global-paragraph-font-family",
          getFontStack(data.paragraph_font_family || "Poppins")
        );
        root.style.setProperty(
          "--global-paragraph-font-weight",
          data.paragraph_font_weight || "400"
        );
        root.style.setProperty(
          "--global-paragraph-color",
          data.paragraph_color || "#777777"
        );
        root.style.setProperty(
          "--global-paragraph-font-size",
          `${data.paragraph_font_size || 16}px`
        );
      } catch (error) {
        console.error("Global font sync error:", error);
      }
    };

    loadGlobalFonts();
  }, []);

  return null;
};

export default GlobalFontStyleSync;